/* tslint:disable */
/* eslint-disable */
/**
 * Ion.Reporting.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from "../runtime";
/**
 *
 * @export
 * @interface MonitoredPropertiesDeveloper
 */
export interface MonitoredPropertiesDeveloper {
  /**
   *
   * @type {string}
   * @memberof MonitoredPropertiesDeveloper
   */
  id?: string | null;
  /**
   *
   * @type {string}
   * @memberof MonitoredPropertiesDeveloper
   */
  name?: string | null;
}

export function MonitoredPropertiesDeveloperFromJSON(json: any): MonitoredPropertiesDeveloper {
  return MonitoredPropertiesDeveloperFromJSONTyped(json, false);
}

export function MonitoredPropertiesDeveloperFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): MonitoredPropertiesDeveloper {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    id: !exists(json, "id") ? undefined : json["id"],
    name: !exists(json, "name") ? undefined : json["name"],
  };
}

export function MonitoredPropertiesDeveloperToJSON(value?: MonitoredPropertiesDeveloper | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    id: value.id,
    name: value.name,
  };
}
